import { Navigate, RouteObject } from 'react-router-dom';
import OnBoarding from '@/modules/Auth/pages/OnBoarding.tsx';
import SelectMode from '@/modules/Auth/pages/SelectMode.tsx';
import Register from '@/modules/Auth/pages/Register.tsx';
import LoginWrapper from '@/modules/Auth/components/wrappers/LoginWrapper.tsx';
import Login from '@/modules/Auth/pages/Login.tsx';
import LoginOtp from '@/modules/Auth/pages/LoginOtp.tsx';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS.ts';

export const AuthRoutes: RouteObject[] = [
  {
    element: <OnBoarding />,
    index: true,
  },
  {
    path: 'select-mode',
    element: <SelectMode />,
  },
  {
    path: 'register',
    element: <Register />,
  },
  {
    path: 'login',
    element: <LoginWrapper />,
    children: [
      { index: true, element: <Login /> },
      { path: 'otp', element: <LoginOtp /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to={AUTH_LINKS.selectMode} />,
  },
];
